const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
const TIME_COMPONENT_WIDTH = 2;

// Hours accumulate rather than wrap at midnight as a date/time formatter would.
function formatDuration(value, secondsPerUnit, roundSeconds) {
  if (value === null || value === undefined
    || !['number', 'string'].includes(typeof value)
    || (typeof value === 'string' && !value.trim())) {
    return '';
  }

  const seconds = Number(value) * secondsPerUnit;
  if (!Number.isFinite(seconds) || seconds < 0) return '';

  const totalSeconds = roundSeconds(seconds);
  const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE) % MINUTES_PER_HOUR;
  const remainingSeconds = totalSeconds % SECONDS_PER_MINUTE;
  return `${hours}:${String(minutes).padStart(TIME_COMPONENT_WIDTH, '0')}:${String(remainingSeconds).padStart(TIME_COMPONENT_WIDTH, '0')}`;
}

// Match duration displays by dropping fractional seconds.
export const formatExportDuration = seconds => formatDuration(seconds, 1, Math.floor);
export const formatExportHours = hours => formatDuration(hours, SECONDS_PER_HOUR, Math.round);
